import {remote} from '../constants/environment';
import {IC2PPaymentFee} from '../interfaces/dtos';
import {IPostC2pPaymentResponse} from '../interfaces/services/responses';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postC2PPaymentFee = async (
  paymentFee: IC2PPaymentFee,
  token: string,
): Promise<IPostC2pPaymentResponse> => {
  const remoteURI = remote.getC2PPaymentPost();

  const handleResponse = async (response: Response) => {
    if (response.status === 200) {
      const data = await response.json();
      const {payload, success} = data;
      if (success && payload) {
        return {
          success: true,
          payload,
        };
      } else {
        return {
          success: false,
          payload,
        };
      }
    }
  };

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        body: JSON.stringify({
          payload: paymentFee,
        }),
      });
    },
    handleResponse,
    remoteURI,
  )) as IPostC2pPaymentResponse;
};
